import { api } from './config'

const propostaService = {

    /**
     * Aceita proposta
     * @param Proposta proposta
     * @param chave chave UID proposta
     */
    aceitaProposta: (proposta, chave) => {
        const dataToSend = {
            idPublicoAlvo: proposta.idPublicoAlvo,
            idPropostaRepactuacao: proposta.idPropostaRepactuacao,
            opcao: "CONCORDO",
            prazoSelecionado: proposta.pzCarenciaAdicionadoFinalSelecionado == null || proposta.pzCarenciaAdicionadoFinalSelecionado == undefined ? undefined : proposta.pzCarenciaAdicionadoFinalSelecionado
        }

        return api.put(`propostarepactuacao/aceitar`, 
            dataToSend,{
            headers: {
                'g-recaptcha-response': chave
            }
        })
    },

    /**
     * Recusar proposta
     * @param Proposta proposta
     * @param chave chave UID proposta
     */
    recusarProposta: (proposta, chave) => {
        const { idPublicoAlvo, idPropostaRepactuacao } = proposta
        const dataToSend = {
            idPublicoAlvo,
            idPropostaRepactuacao,
            "opcao": "NAO_CONCORDO"
        }

        return api.put(`propostarepactuacao/aceitar`, dataToSend, {
            headers: {
                'g-recaptcha-response': chave
            }
        })
    }
}

export default propostaService
